export const getTextData = async (pathToFile, preprocessDataFunc) => {
  const res = await fetch(pathToFile);

  const text = await res.json();

  if (preprocessDataFunc) return preprocessDataFunc(text);

  return text;
};
